import { render, staticRenderFns } from "./alipay.vue?vue&type=template&id=7b8133e4&"
import script from "./alipay.vue?vue&type=script&lang=js&"
export * from "./alipay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports